import React, { useState } from "react";
import { useEffect } from "react";
import { useAlert } from "react-alert";
import { Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import api from "../../api";
import { ConsentTerms } from "./consentTerms";
import userAction from "../../redux/users/action";
import "./beforePayTermsModal.css";

const FIELDS = [
  "confirmAccount",
  "authCard",
  "monthlysubs",
  "renewAuto",
  "nonRefund",
  "aggreeTerms",
  "understandMisuse",
  "unauthTransaction",
];

export const BeforePayTerms = ({
  show,
  handleShow,
  handleClose,
  onStripePay,
  onSquarePay,
}) => {
  const userStore = useSelector((state) => state.userReducer);
  const alert = useAlert();
  const [data, setData] = useState({});
  const [loader, setLoader] = useState(false);
  const [showPaymentOptions, setShowPaymentOptions] = useState(false);

  useEffect(() => {
    if (!show) {
      setShowPaymentOptions(false);
      setData({});
    }
  }, [show]);

  const accept = async () => {
    try {
      const validatorsResponse = validators();

      if (validatorsResponse) {
        return alert.show(validatorsResponse);
      }
      setLoader(true);
      const payload = {
        confirmAccount: data.confirmAccount,
        authCard: data.authCard,
        monthlySubscription: data.monthlysubs,
        renewAuto: data.renewAuto,
        nonRefund: data.nonRefund,
        aggreeTerms: data.aggreeTerms,
        understandMisuse: data.understandMisuse,
        unauthTransaction: data.unauthTransaction,
      };

      const response = await api.addSubscriptionConsents(payload);
      if (response?.consent) {
        setShowPaymentOptions(true);
        setLoader(false);
      }
    } catch (error) {
      console.log(error?.message);
      alert.show("Something went wrong");
      setLoader(false);
    }
  };

  const validators = () => {
    if (!data?.confirmAccount) {
      return "Kindly confirm each checkbox to proceed.";
    }
    if (!data?.authCard) {
      return "Kindly confirm each checkbox to proceed.";
    }
    if (!data?.monthlysubs) {
      return "Kindly confirm each checkbox to proceed.";
    }
    if (!data?.renewAuto) {
      return "Kindly confirm each checkbox to proceed.";
    }
    if (!data?.nonRefund) {
      return "Kindly confirm each checkbox to proceed.";
    }
    if (!data?.aggreeTerms) {
      return "Kindly confirm each checkbox to proceed.";
    }
    if (!data?.understandMisuse) {
      return "Kindly confirm each checkbox to proceed.";
    }
    if (!data?.unauthTransaction) {
      return "Kindly confirm each checkbox to proceed.";
    }
    return false;
  };

  const toggleField = (name) => (e) => {
    if (e.target.tagName === "A") return;
    setData((prev) => ({ ...prev, [name]: !prev[name] }));
  };

  const doneCount = FIELDS.filter((f) => data[f]).length;
  const totalCount = FIELDS.length;
  const allDone = doneCount === totalCount;
  const progressPct = Math.round((doneCount / totalCount) * 100);

  return (
    <Modal
      size="lg"
      show={show}
      onHide={handleClose}
      centered
      dialogClassName="bpt-dialog"
      contentClassName="bpt-content"
    >
      <div className="bpt-modal">
        <div className="bpt-head">
          <div className="bpt-blob b1"></div>
          <div className="bpt-blob b2"></div>
          <button
            type="button"
            className="bpt-close"
            aria-label="Close"
            onClick={handleClose}
          >
            <i className="fa-solid fa-xmark" />
          </button>
          <div className="bpt-head-inner">
            <div className="bpt-pill">&#128274; Secure Checkout</div>
            <h2 className="bpt-title">
              {showPaymentOptions
                ? // ? "Choose Your Payment Method"
                  "Complete Your Payment"
                : "Before You Subscribe, Please Confirm the Following"}
            </h2>
            {!showPaymentOptions && (
              <div className="bpt-progress-wrap">
                <div className="bpt-progress-meta">
                  <span>
                    {allDone
                      ? "All confirmations complete"
                      : `${doneCount} of ${totalCount} confirmed`}
                  </span>
                  <span>{progressPct}%</span>
                </div>
                <div className="bpt-track">
                  <div
                    className={`bpt-fill${allDone ? " complete" : ""}`}
                    style={{ width: `${progressPct}%` }}
                  ></div>
                </div>
              </div>
            )}
          </div>
        </div>

        {showPaymentOptions ? (
          <>
            <div className="bpt-body bpt-choose-body">
              <div className="bpt-choose-inner">
                <div className="bpt-choose-check">&#10003;</div>
                <h3 className="bpt-choose-title">Terms Accepted</h3>
                <p className="bpt-choose-sub">
                  Select your preferred payment method to complete your
                  subscription.
                </p>
                <div className="bpt-cards-row">
                  <svg
                    width="42"
                    height="26"
                    viewBox="0 0 42 26"
                    xmlns="http://www.w3.org/2000/svg"
                    className="bpt-card-icon"
                  >
                    <rect width="42" height="26" rx="4" fill="#1A1F71" />
                    <text
                      x="21"
                      y="18"
                      textAnchor="middle"
                      fill="#FFFFFF"
                      fontSize="12"
                      fontFamily="Arial"
                      fontWeight="bold"
                      fontStyle="italic"
                    >
                      VISA
                    </text>
                  </svg>
                  <svg
                    width="42"
                    height="26"
                    viewBox="0 0 42 26"
                    xmlns="http://www.w3.org/2000/svg"
                    className="bpt-card-icon"
                  >
                    <rect width="42" height="26" rx="4" fill="#1A1A1A" />
                    <circle cx="16" cy="13" r="8" fill="#EB001B" />
                    <circle cx="26" cy="13" r="8" fill="#F79E1B" />
                    <path
                      d="M21 6.5a8 8 0 0 1 0 13A8 8 0 0 1 21 6.5z"
                      fill="#FF5F00"
                    />
                  </svg>
                  <svg
                    width="42"
                    height="26"
                    viewBox="0 0 42 26"
                    xmlns="http://www.w3.org/2000/svg"
                    className="bpt-card-icon"
                  >
                    <rect width="42" height="26" rx="4" fill="#007BC1" />
                    <text
                      x="21"
                      y="17"
                      textAnchor="middle"
                      fill="#FFFFFF"
                      fontSize="9"
                      fontFamily="Arial"
                      fontWeight="bold"
                      letterSpacing="0.5"
                    >
                      AMEX
                    </text>
                  </svg>
                  <svg
                    width="42"
                    height="26"
                    viewBox="0 0 42 26"
                    xmlns="http://www.w3.org/2000/svg"
                    className="bpt-card-icon"
                  >
                    <rect
                      width="42"
                      height="26"
                      rx="4"
                      fill="#fff"
                      stroke="#ddd"
                      strokeWidth="1"
                    />
                    <rect
                      x="4"
                      y="5"
                      width="11"
                      height="16"
                      rx="2"
                      fill="#003087"
                    />
                    <rect
                      x="15.5"
                      y="5"
                      width="11"
                      height="16"
                      rx="2"
                      fill="#CC0000"
                    />
                    <rect
                      x="27"
                      y="5"
                      width="11"
                      height="16"
                      rx="2"
                      fill="#009A44"
                    />
                    <text
                      x="9.5"
                      y="16"
                      textAnchor="middle"
                      fill="#fff"
                      fontSize="7"
                      fontFamily="Arial"
                      fontWeight="bold"
                    >
                      J
                    </text>
                    <text
                      x="21"
                      y="16"
                      textAnchor="middle"
                      fill="#fff"
                      fontSize="7"
                      fontFamily="Arial"
                      fontWeight="bold"
                    >
                      C
                    </text>
                    <text
                      x="32.5"
                      y="16"
                      textAnchor="middle"
                      fill="#fff"
                      fontSize="7"
                      fontFamily="Arial"
                      fontWeight="bold"
                    >
                      B
                    </text>
                  </svg>
                </div>
              </div>
            </div>
            <div className="bpt-foot bpt-foot-choose">
              <button
                type="button"
                className="bpt-cta ready bpt-pay-btn"
                onClick={() => {
                  onStripePay();
                  handleClose();
                }}
              >
                <span className="bpt-shine"></span>
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  style={{ marginRight: "8px", flexShrink: 0 }}
                >
                  <path d="M13.976 9.15c-2.172-.806-3.356-1.426-3.356-2.409 0-.831.683-1.305 1.901-1.305 2.227 0 4.515.858 6.09 1.631l.89-5.494C18.252.975 15.697 0 12.165 0 9.667 0 7.589.654 6.104 1.872 4.56 3.147 3.757 4.992 3.757 7.218c0 4.039 2.467 5.76 6.476 7.219 2.585.92 3.445 1.574 3.445 2.583 0 .98-.84 1.545-2.354 1.545-1.875 0-4.965-.921-6.99-2.109l-.9 5.555C5.175 22.99 8.385 24 11.714 24c2.641 0 4.843-.624 6.328-1.813 1.664-1.305 2.525-3.236 2.525-5.732 0-4.128-2.524-5.851-6.591-7.305z" />
                </svg>
                <span className="label">Pay with Stripe</span>
              </button>
              {/* <button
                type="button"
                className="bpt-cta-square bpt-pay-btn"
                onClick={() => { handleClose(); onSquarePay && onSquarePay(); }}
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" style={{ marginRight: "8px", flexShrink: 0 }}>
                  <rect x="2" y="2" width="20" height="20" rx="3"/>
                  <rect x="7" y="7" width="10" height="10" rx="1" fill="#1a1a2e"/>
                </svg>
                <span className="label">Pay with Square</span>
              </button> */}
            </div>
          </>
        ) : (
          <>
            <div className="bpt-body">
              <div className="bpt-list">
                <div
                  className={`bpt-row${data.confirmAccount ? " is-checked" : ""}`}
                  onClick={toggleField("confirmAccount")}
                >
                  <div className="bpt-box">
                    <span className="num">1</span>
                    <span className="tick">&#10003;</span>
                  </div>
                  <span className="bpt-text">
                    I confirm that I am the owner of this account.
                  </span>
                </div>

                <div
                  className={`bpt-row${data.authCard ? " is-checked" : ""}`}
                  onClick={toggleField("authCard")}
                >
                  <div className="bpt-box">
                    <span className="num">2</span>
                    <span className="tick">&#10003;</span>
                  </div>
                  <span className="bpt-text">
                    I confirm that I am using my own credit/debit card or have
                    authorized access to this card.
                  </span>
                </div>

                <div
                  className={`bpt-row${data.monthlysubs ? " is-checked" : ""}`}
                  onClick={toggleField("monthlysubs")}
                >
                  <div className="bpt-box">
                    <span className="num">3</span>
                    <span className="tick">&#10003;</span>
                  </div>
                  <span className="bpt-text">
                    I authorize WaqarZaka.net to charge my card for a monthly
                    subscription.
                  </span>
                </div>

                <div
                  className={`bpt-row${data.renewAuto ? " is-checked" : ""}`}
                  onClick={toggleField("renewAuto")}
                >
                  <div className="bpt-box">
                    <span className="num">4</span>
                    <span className="tick">&#10003;</span>
                  </div>
                  <span className="bpt-text">
                    I understand that after my first month’s payment, my
                    subscription will automatically renew each month unless I
                    cancel it in advance.
                  </span>
                </div>

                <div
                  className={`bpt-row${data.nonRefund ? " is-checked" : ""}`}
                  onClick={toggleField("nonRefund")}
                >
                  <div className="bpt-box">
                    <span className="num">5</span>
                    <span className="tick">&#10003;</span>
                  </div>
                  <span className="bpt-text">
                    I understand this is a non-refundable digital subscription,
                    and after 12 hours of purchase, no refund requests will be
                    accepted.
                  </span>
                </div>

                <div
                  className={`bpt-row${data.aggreeTerms ? " is-checked" : ""}`}
                  onClick={toggleField("aggreeTerms")}
                >
                  <div className="bpt-box">
                    <span className="num">6</span>
                    <span className="tick">&#10003;</span>
                  </div>
                  <span className="bpt-text">
                    I agree to the platform’s{" "}
                    <Link to="/terms-and-conditions">Terms & Conditions</Link>{" "}
                    and <Link to="/privacy-policy">Privacy Policy.</Link>
                  </span>
                </div>

                <div
                  className={`bpt-row${data.understandMisuse ? " is-checked" : ""}`}
                  onClick={toggleField("understandMisuse")}
                >
                  <div className="bpt-box">
                    <span className="num">7</span>
                    <span className="tick">&#10003;</span>
                  </div>
                  <span className="bpt-text">
                    I understand that misuse, account sharing, or reselling
                    content may lead to account suspension without refund.
                  </span>
                </div>

                <div
                  className={`bpt-row${data.unauthTransaction ? " is-checked" : ""}`}
                  onClick={toggleField("unauthTransaction")}
                >
                  <div className="bpt-box">
                    <span className="num">8</span>
                    <span className="tick">&#10003;</span>
                  </div>
                  <span className="bpt-text">
                    I agree that any unauthorized or fraudulent activity may
                    lead to data disclosure, account suspension, and legal
                    action.{" "}
                    <Link to={"/unauthorized-transaction"}>For more info</Link>
                  </span>
                </div>
              </div>
            </div>

            <div className="bpt-foot">
              <button
                type="button"
                className="bpt-cancel"
                onClick={handleClose}
              >
                Cancel
              </button>
              <button
                type="button"
                className={`bpt-cta${allDone ? " ready" : ""}`}
                disabled={!allDone || loader}
                onClick={accept}
              >
                <span className="bpt-shine"></span>
                <span className="label">
                  {loader ? (
                    <i className="fa fa-spinner fa-pulse" />
                  ) : allDone ? (
                    "Accept & Continue"
                  ) : (
                    `Confirm all ${totalCount} items`
                  )}
                </span>
              </button>
            </div>
          </>
        )}
      </div>
    </Modal>
  );
};
